import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn } from '@angular/router';
import { combineLatest, map } from 'rxjs';
import { filterNil } from '../../../../utils/rxjs-operators';
import { FeatureService } from '../../../_services/utils/feature.service';
import { AuthStore } from '../../../auth.store';

export const campaignCreationGuard: CanActivateFn = () => {
  const featureService = inject(FeatureService);
  const authStore = inject(AuthStore);

  return combineLatest({
    isLoggedIn: toObservable(authStore.isLoggedIn).pipe(filterNil()),
    isAdmin: toObservable(authStore.isGlobalAdmin).pipe(filterNil()),
    canCreatePublicly: toObservable(featureService.features$.value).pipe(
      filterNil(),
      map((config) => config.enablePublicCampaignCreation),
    ),
  }).pipe(
    map(({ isLoggedIn, isAdmin, canCreatePublicly }) => {
      if (!isLoggedIn) return false;
      if (canCreatePublicly) return true;

      return isAdmin;
    }),
  );
};
